'use client';

import { Dropdown } from '@mui/base/Dropdown';
import { useState } from 'react';
import { Menu } from '@mui/base/Menu';
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton';
import { styled, useTheme } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';
const MenuButton = styled(BaseMenuButton)(({
  theme
}) => ({
  transition: 'all 150ms ease',
  cursor: 'pointer',
  background: 'transparent',
  border: 'none',
  color: theme.palette.text.primary,
  '&:hover': {
    background: 'transparent'
  },
  '&:active': {
    background: 'transparent'
  },
  '&:focus-visible': {
    outline: 'none'
  }
}));
export function ActionsDropdown({
  children,
  openOnHover = false,
  trigger,
  ariaLabel = 'More actions'
}) {
  const [showDropDown, setShowDropDown] = useState(false);
  const theme = useTheme();
  const toggleDropdownMenu = () => {
    setShowDropDown(prev => !prev);
  };
  return <div role="button" className="flex items-center justify-center flex-row h-full" onMouseEnter={() => {
    if (openOnHover) setShowDropDown(true);
  }} onMouseLeave={() => {
    if (openOnHover) setShowDropDown(false);
  }} onClick={toggleDropdownMenu}>
            <Dropdown open={showDropDown}>
                <MenuButton aria-label={ariaLabel}>{trigger ?? <MoreVertIcon />}</MenuButton>
                <Menu style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px',
        borderRadius: '16px',
        overflow: 'auto',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[8],
        zIndex: 6
      }} slotProps={{
        listbox: {
          style: {
            padding: '0px',
            paddingLeft: '4px',
            paddingRight: '4px',
            margin: '0px',
            display: 'flex',
            flexDirection: 'row',
            gap: '4px'
          }
        }
      }}>
                    {children}
                </Menu>
            </Dropdown>
        </div>;
}